import React from "react";
import { Busy } from "../presentational/busy";
import ReactGA from "react-ga";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import styles from "../../styles/panels/shareSpend.css";

export class ShareSpend extends React.Component {
  constructor(props) {
    super(props);
    let banner =
      this.props.images.share_banners[
        Math.floor(Math.random() * this.props.images.share_banners.length)
      ];
    this.state = {
      banner: banner,
    };
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/Share");
    if (!this.props.code) {
      this.props.onEmptyCode();
    } else {
      fbq("trackCustom", "SpendCard", {
        value: this.props.donation.amount,
        currency: "USD",
        content_name: "tisbestcard",
      });
    }
  }
  render() {
    if (this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          {this.props.donation &&
          this.props.donation.campaignDetail &&
          this.props.donation.campaignDetail.confirmationMarkup ? (
            // <div
            //   className={styles.banner}
            //   dangerouslySetInnerHTML={{
            //     __html: this.props.donation.campaignDetail.confirmationMarkup
            //   }}
            // />
            <div
              className={styles.banner}
              style={{
                backgroundImage:
                  "url(" +
                  this.props.donation.campaignDetail.confirmationMarkup +
                  ")",
              }}
            />
          ) : (
            <div
              className={styles.banner}
              style={{ backgroundImage: "url(" + this.state.banner.src + ")" }}
            />
          )}
          <div className={styles.content}>
            <div className={styles.header}>
              {this.props.selectedCharities.length > 1
                ? this.props.dictionary.share_header_plural
                : this.props.dictionary.share_header_single}
            </div>
            <div className={styles.message}>
              {this.props.selectedCharities.length > 1
                ? this.props.dictionary.share_message_plural
                : this.props.dictionary.share_message_single}
            </div>
            {this.props.selectedCharities.length > 0 ? (
              <ul>
                {this.props.selectedCharities.map((charity) => {
                  return <li>{charity.name}</li>;
                })}
              </ul>
            ) : null}
            {this.props.dictionary.share_call_to_action ? (
              <div className={styles.calltoaction}>
                {this.props.dictionary.share_call_to_action}
              </div>
            ) : null}
            <div className={styles.information}>
              {this.props.selectedCharities.length > 1
                ? this.props.dictionary.share_information_plural
                : this.props.dictionary.share_information_single}
            </div>
            <div className={styles.social}>
              <FacebookShareButton
                className={styles.socialIcon}
                url={this.props.links.share_facebook}
                //quote={this.props.dictionary.share_facebook}
                hashtag="#whatsyourcause"
              >
                <img
                  className={styles.icon}
                  src={this.props.images.share_facebook.src}
                  alt={this.props.images.share_facebook.alt}
                />
              </FacebookShareButton>
              <TwitterShareButton
                className={styles.socialIcon}
                url={this.props.links.share_twitter}
                quote={this.props.dictionary.share_twitter}
                hashtags={["bettergift", "whatsyourcause"]}
              >
                <img
                  className={styles.icon}
                  src={this.props.images.share_twitter.src}
                  alt={this.props.images.share_twitter.alt}
                />
              </TwitterShareButton>
              <div className={styles.socialIcon}>
                <a href={this.props.links.share_instagram} target="_blank">
                  <img
                    className={styles.icon}
                    src={this.props.images.share_instagram.src}
                    alt={this.props.images.share_instagram.alt}
                  />
                </a>
              </div>
              <LinkedinShareButton
                className={styles.socialIcon}
                url={this.props.links.share_linkedin}
                quote={this.props.dictionary.share_linkedin}
              >
                <img
                  className={styles.icon}
                  src={this.props.images.share_linkedin.src}
                  alt={this.props.images.share_linkedin.alt}
                />
              </LinkedinShareButton>
            </div>
            <div className={styles.tip}>{this.props.dictionary.share_tip}</div>
          </div>
        </div>
      );
    }
  }
}
